<template>
  <svg xmlns="http://www.w3.org/2000/svg" :class="{ up }" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="5">
    <use class="svg-colorized-el" transform="rotate(180 5 2.5)" xlink:href="#icon-tendency_fill"/>
    <defs>
      <path id="icon-tendency_fill" d="M10 5H0l5-5 5 5z"/>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    up: Boolean, // down by default
  },
};
</script>


<style lang="scss" scoped>
.up {
  transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/icons/IconArrowMinFilled.vue